// extracted by mini-css-extract-plugin
export default {"grading":"grading_grading__Mq-lA","grading-details":"grading_grading-details__FlACs","font-normal":"grading_font-normal__iIQbJ","visual-img":"grading_visual-img__AtXoD"};